import {
	StackCompat as Stack,
	TooltipHostCompat as TooltipHost,
} from 'components/FluentUICompat';
import {StatusField} from 'components/EntityList/ColumnRenderers';
import {isApprovalModified} from 'features/RegulatoryDocuments/regulatoryUtils';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {WorkflowStatus} from 'types';

export const useDashboardRenderers = () => {
	const {t: tEnum} = useTranslation('common/enums');

	const renderWorkflowStatus = (
		item: any,
		index: number | undefined,
		column: any,
	) => {
		// QualityControl status is missing ?
		const getTooltipContent = () => {
			switch (item?.workflow?.status) {
				case WorkflowStatus.New:
					return tEnum('WorkflowStatusTooltip.NEW');
				case WorkflowStatus.InProgressInternal:
					return tEnum('WorkflowStatusTooltip.IN_PROGRESS_INTERNAL');
				case WorkflowStatus.InProgressExternal:
					return tEnum('WorkflowStatusTooltip.IN_PROGRESS_EXTERNAL');
				case WorkflowStatus.Clearing:
					return tEnum('WorkflowStatusTooltip.CLEARING');
				case WorkflowStatus.Finalized:
					return tEnum('WorkflowStatusTooltip.FINALIZED');
				case WorkflowStatus.Modified:
					if (isApprovalModified(item?.workflow?.reapprovingVKO?.id || ''))
						return tEnum('WorkflowStatusTooltip.MODIFIED');
					return tEnum('WorkflowStatusTooltip.APPROVING_MODIFIED');
				default:
					return '';
			}
		};

		const statusValue =
			item?.workflow?.status === WorkflowStatus.Modified &&
			isApprovalModified(item?.workflow?.reapprovingVKO?.id || '')
				? 'APPROVING_MODIFIED'
				: item?.workflow?.status;

		return (
			<TooltipHost content={getTooltipContent()}>
				<StatusField
					item={item}
					i={index}
					col={column}
					value={statusValue}
					enumName={'WorkflowStatus'}
				/>
			</TooltipHost>
		);
	};

	const renderApprover = (item: any) => {
		const name =
			item?.workflow?.clearingVKO?.length > 0
				? item.workflow.clearingVKO[0].name
				: item?.workflow?.reapprovingVKO?.name;
		return (
			<Stack>
				<Stack.Item>{name}</Stack.Item>
			</Stack>
		);
	};

	return {renderWorkflowStatus, renderApprover};
};
